import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useStateIfMounted } from "use-state-if-mounted";
import { DEFAULT_WATERBODY_INFO_STATE } from "../WaterbodiesSetup/WaterbodiesConstants";

export const useWaterbodyInfo = (selectedWaterbody) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_WATERBODY_INFO_STATE
  );
  const [isDirty, setIsDirty] = useStateIfMounted(false);

  const handleUpdateState = (name, value) => {
    if (!isDirty) setIsDirty(true);
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };
      newFilterValues[name] = value;
      return newFilterValues;
    });
  };

  const handleResetState = () => {
    setIsDirty(false);
    if (selectedWaterbody) {
      setEditorState(data);
    } else {
      setEditorState(DEFAULT_WATERBODY_INFO_STATE);
    }
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["data-list-waterbodies", selectedWaterbody],
    async () => {
      if (!selectedWaterbody) {
        setIsDirty(false);
        setEditorState(DEFAULT_WATERBODY_INFO_STATE);
        return {};
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/data-list-waterbodies/${selectedWaterbody}`,
          { headers }
        );
        setIsDirty(false);
        setEditorState(data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    isDirty,
    lookups: {},
    handleUpdateState,
    handleResetState,
    state: editorState,
    setter: setEditorState,
  };
};
